import { useState, useEffect } from "react";
import API_URL from "../config";
import { useGlobal } from "../context/ContenedorGlobal";
import "../styles/Formularios.css";
import { obtenerModulosDesdePermisos } from "../data/permisosUtils";
import InputContrasena from "./InputContrasena";
import InputGenerico from "./InputGenerico";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useNavigate } from "react-router-dom";

function IniciarSesion() {
    const { setIdentidad, setModuloActual, setSubModuloActual, setPermisos } = useGlobal();
    const [idTecnico, setIdTecnico] = useState("");
    const [contrasena, setContrasena] = useState("");
    const [mensaje, setMensaje] = useState("");
    const [tipoMensaje, setTipoMensaje] = useState("");
    const { executeRecaptcha } = useGoogleReCaptcha();
    const navigate = useNavigate();

    // Efecto para limpiar el mensaje después de 2 segundos
    useEffect(() => {
        if (mensaje) {
            const timer = setTimeout(() => {
                setMensaje("");
                setTipoMensaje("");
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [mensaje]);

    const enviarFormulario = async (e) => {
        e.preventDefault();
        setMensaje("");
        setTipoMensaje("");

        if (!executeRecaptcha) {
            console.log("Recaptcha no está listo");
            return;
        }

        if (!idTecnico || !contrasena) {
            setMensaje("Todos los campos son obligatorios.");
            setTipoMensaje("error");
            return;
        }

        if (idTecnico.length !== 7) {
            setMensaje("El número de empleado debe tener exactamente 7 dígitos.");
            setTipoMensaje("error");
            return;
        }

        const regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
        if (!regexPassword.test(contrasena)) {
            setMensaje("La contraseña debe tener mínimo 8 caracteres, incluir mayúscula, minúscula, número y carácter especial.");
            setTipoMensaje("error");
            return;
        }

        try {
            const token = await executeRecaptcha("login");

            const response = await fetch(`${API_URL}/login.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id_tecnico: idTecnico, contrasena, token }),
                credentials: "include"
            });

            const data = await response.json();

            if (data.status !== "ok") {
                setTipoMensaje("error");
                setMensaje(data.message || "Credenciales incorrectas.");
                return;
            }

            // Inicio de sesión exitoso
            setIdentidad(data.identidad);
            setPermisos(data.permisos);
            setSubModuloActual(null);

            let modulosPermitidos = obtenerModulosDesdePermisos(data.permisos)
                .filter(m => m !== "Autenticación" && m !== "Ingresar");
            setModuloActual(modulosPermitidos.length > 0 ? modulosPermitidos[0] : "Autenticación");

            setTipoMensaje("success");
            setMensaje("Inicio de sesión exitoso.");
            navigate("/");

        } catch (error) {
            console.error(error);
            setTipoMensaje("error");
            setMensaje("Error de conexión con el servidor.");
        }
    };

    return (
        <div className="sesion-form">
            {mensaje && (
                <p className={tipoMensaje === "success" ? "success" : "error"}>
                    {mensaje}
                </p>
            )}

            <form onSubmit={enviarFormulario}>
                <InputGenerico
                    value={idTecnico}
                    setValue={setIdTecnico}
                    label="Número de empleado"
                    maxLength={7}
                    allowedChars="0-9"
                    placeholder="7120000"
                    title="Ingrese exactamente 7 dígitos"
                />

                <InputContrasena
                    contrasena={contrasena}
                    setContrasena={setContrasena}
                    label="Contraseña"
                />

                <div className="form-buttons">
                    <button type="submit">Entrar</button>
                </div>
            </form>
        </div>
    );
}

export default IniciarSesion;